/** @jsxImportSource @emotion/react */

import { Screen } from "../components";
import * as colors from "../styles/colors";

function NoMetamask() {
  return (
    <Screen showHeader={false}>
      <div
        css={{
          textAlign: "center",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
        }}
      >
        <p>Metamask wallet not found!</p>
        <p css={{ marginTop: "1em" }}>
          Download{" "}
          <a href="https://metamask.io/" css={{ color: colors.secondary }}>
            Metamask
          </a>{" "}
          and retry
        </p>
      </div>
    </Screen>
  );
}

export default NoMetamask;
